/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { Select } from 'antd'
import React from 'react'
import {
  paragraphMedium,
  paragraphSmall,
  weightRegular,
} from 'src/components/css'
import { ErrorLabel } from '../ErrorLabel'

type SelectInputProps = {
  label: string
  disabled: boolean
  options: any[]
  name: string
  value: string
  onChange: (value: string) => void
  fieldErrors: any
  customError: any
  showSearch?: boolean
  filterOption?: (input: string, option: any) => boolean
  style?: any
}

export const SelectInput: React.FC<SelectInputProps> = ({
  label,
  disabled,
  options,
  name,
  value,
  onChange,
  fieldErrors,
  customError,
  showSearch = false,
  filterOption,
  style,
}) => {
  return (
    <>
      <style>
        {`
          .ant-select-dropdown {
            z-index: 999999 !important;
          }
          .ant-select-selector {
            background: ${colors.SECONDARY_200} !important;
            border-radius: 8px !important;
          }
          .ant-select-selection-item {
            font-size: 16px !important;
            font-weight: 400 !important;
            color: ${colors.WHITE} !important;
          }
        `}
      </style>
      <p
        css={css`
          ${paragraphSmall}
          ${weightRegular}
                color: ${colors.WHITE};
          align-self: stretch;
        `}
      >
        {label}
      </p>
      <Select
        disabled={disabled}
        showSearch={showSearch}
        onChange={(e) => onChange(e)}
        options={options}
        value={value}
        css={css`
          ${paragraphMedium}
          ${weightRegular}
          color: ${colors.WHITE};
          width: 100%;
          background: ${colors.SECONDARY_200} !important;
          border-radius: 8px !important;
          ${style}
        `}
        filterOption={filterOption}
      />
      <ErrorLabel
        fieldErrors={fieldErrors}
        customError={customError}
        name={name}
      />
    </>
  )
}
